/**
 * @file 首页
 * @author wangzhuang
 */

import {
    GET_USER_INFO
} from '../actions/ActionTypes';

export function userInfo(state = {}, action) {
    switch (action.type) {
        case GET_USER_INFO:
            if (action.data) {
                state = action.data;
                return state;
            }
            return {};
        default:
            return state;
    }
}
